import React ,{useState} from 'react';

//import {Card} from 'react-bootstrap';
import {Link} from '@reach/router';

//import Heart from '../../components/Heart/Heart.js'

import {ReactComponent as SvgPin} from '../../assets/image/location_outline.svg';

import './CardEvent.scss';

const CardEvent = (props) => {
    const {
        id = 0,
        date='xx',
        thumbnail=null,
        thumbnail_credit=null,
        categorie='Catégorie',
        titre='Titre',
        ville= false,
        filterQuery = '',
        //location_lat = false,
        //location_lng = false,
        //userLat = false,
        //userLng = false
        //distance='X'
    } = props;
    let navigateTo = '/evenement/'+id;
    const dateObject = (date !== '') ? date.split('-') : '';
    if(date !== 'xx'){
        navigateTo = '/evenement/'+id+'/'+dateObject[0];
    }
    if (filterQuery) {
        navigateTo += `?search=1${filterQuery}`;
    }
    const persistScroll = () => {
        window.localStorage.setItem('LastScrollPos', window.scrollY);
    };
    const cardAriaLabel = ville
        ? `Consulter l'événement : ${titre}, ${ville}`
        : `Consulter l'événement : ${titre}`;
    const [distance,setDistance] = useState(false);
    let categWord = categorie;
    if(categWord === 'Local'){
        categWord = 'Locale';
    }else if(categWord === 'Régional'){
        categWord = 'Régionale';
    }else if(categWord === 'National'){
        categWord = 'Nationale';
    }
    /*useEffect(()=>{
        const calcCrow = (lat1, lon1, lat2, lon2) =>{
            var R = 6371; // km
            var dLat = toRad(lat2-lat1);
            var dLon = toRad(lon2-lon1);
            lat1 = toRad(lat1);
            lat2 = toRad(lat2);
            
            var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
            var d = R * c;
            return d;
        }
        // Converts numeric degrees to radians
        const toRad = (Value) =>{
            return Value * Math.PI / 180;
        }
        if (userLat && userLng && location_lat && location_lng) {
            setDistance(Math.round(calcCrow(userLat,userLng,location_lat,location_lng)));
        }
    },[distance,location_lat,location_lng,userLng,userLat])*/
    //console.log(dateObject);
    return (
        <Link
            className="CardEvent card"
            to={navigateTo}
            onClick={persistScroll}
            aria-label={cardAriaLabel}
        >
            <figure className="thumb">
                {thumbnail && (
                    <img src={'https://paf.fetenationale.gouv.qc.ca/'+thumbnail} loading="lazy" alt={titre} />
                )}
                {
                    thumbnail && thumbnail_credit && (
                        <figcaption className="credit">{thumbnail_credit}</figcaption>
                    )
                }
                <div className="date">
                    <div className="day">{dateObject[0]}</div>
                    <div className="month">juin</div>
                </div>
            </figure>
            <div className="card-body">
                <div>
                    <div className="categ">
                        <h6>{categWord}</h6>
                        {/*<Heart id={id} />*/}
                    </div>
                    <div><h5>{titre}</h5></div>
                    {ville && (
                        <div className="ville">{ville}</div>
                    )}
                </div>
                {distance && (
                    <div className="distance">
                        <SvgPin />Distance {distance}km
                    </div>
                )}
            </div>
        </Link>
    )
}
        
export default CardEvent;